<template>
  <div style="width: 100%;">
    <el-row type="flex" justify="start" align="middle">
      <table style="margin: 0; table-layout: fixed;">
        <col width="120">
        <col width="200">
        <tr v-if="checksToDisplay && checksToDisplay.length === 1">
          <td>
            <div class="check-header-cell">Check{{ ` (${checksToDisplay[0].status || ''})` }}</div>
          </td>
          <td class="check-detail-cell">
            <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ checksToDisplay[0].meta_name}}
            </div>
          </td>
        </tr>
        <tr v-else-if="checksToDisplay && checksToDisplay.length > 1">
          <td>
            <div class="check-header-cell">Total Associated Checks</div>
          </td>
          <td style="text-align: left;">
            <span class="check-detail-cell">{{ checksToDisplay.length }}</span>
            <el-button size="mini" :plain="true" @click="handleDialogVisible(true)">
              View all
            </el-button>
          </td>
        </tr>
        <tr v-else>
          <td>
            <div class="check-header-cell">Checks</div>
          </td>
          <td>
            <span class="check-detail-cell">None</span>
          </td>
        </tr>
      </table>
    </el-row>
    <el-dialog
      title="Associated checks"
      :visible.sync="dialogVisible"
      size="small"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      v-if="checksToDisplay && checksToDisplay.length">
      <el-table
        id="ap-check-table"
        :data="checksToDisplay"
        border style="width: 100%; z-index: 0;"
        ref="apCheckTable"
        :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column prop="number" label="#" align="left" width="90" />
        <el-table-column prop="date" label="Date" align="left" width="110" />
        <el-table-column prop="amount_decimal" label="Amount" align="left" width="90">
          <template slot-scope="scope">
            <el-row type="flex" justify="start">
              ${{ formatAmountLocale(scope.row.amount_decimal) }}
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="vendor" label="Payee" align="left" fit>
          <template slot-scope="scope">
            <el-row type="flex" justify="start">
              {{ getVendorById(scope.row.vendor).name }}
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status" width="120">
          <template slot-scope="scope">
            {{scope.row && scope.row.recon ? 'CLEARED' : scope.row.status}}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" @click="handleDialogVisible(false)">
          Close
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'

  export default {
    props: {
      checks: Array
    },
    data () {
      return {
        dialogVisible: false
      }
    },
    methods: {
      formatAmountLocale (value) {
        return formatAmount(value)
      },
      handleDialogVisible (visibleState) {
        this.dialogVisible = visibleState
      }
    },
    computed: {
      ...mapGetters({
        getVendorById: 'getVendorById'
      }),
      /**
       * Returns the array of checks after updating their status to 'CLEARED' if they have a recon value > 0
       */
      checksToDisplay () {
        return this.checks.map(check => {
          let clone = { ...check }  // Clone check so we don't mutate original check object
          if (!(check && check.status)) {
            return clone
          }
          const { status, recon } = check
          if (status && (status === 'POSTED' || status === 'CLOSED') && recon && recon > 0) {
            clone.status = 'CLEARED'
          }
          return clone
        })
      }
    }
  }
</script>

<style>
  td input {
    border: none !important;
    height: 22px !important;
  }
  td textarea {
    border: none !important;
    height: 22px !important;
  }
</style>

<style scoped>
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    border: 1px solid #ccc;
    background-color: #ffffff;
    font-size: 12px;
  }
  td:nth-child(2) div {
    text-align: left;
    color: gray;
    margin: 0 6px;
  }
  td:first-child {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(2) {
    text-align: left;
  }
  td:nth-child(3) {
    text-align: right;
    background-color: #efefef;
    padding: 3px;
  }
  td:nth-child(4) {
    text-align: left;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .no-checks-notif {
    width: 100%;
    text-align: center;
    padding: 30px;
    color: gray;
    border: 1px solid lightgray;
  }
  .check-header-cell {
    padding: 3px;
  }
  .check-detail-cell {
    margin: 0 10px;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Aps/ApCheckList.vue